import { render, staticRenderFns } from "./edit-product-name.vue?vue&type=template&id=0cfdd5ab"
import script from "./edit-product-name.vue?vue&type=script&lang=ts"
export * from "./edit-product-name.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports